import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ChromePicker } from 'react-color';
import WveInputButton from '../WveInputButton/WveInputButton';

const MULTIPLE = 'multiple';

const ColourPickerContainer = styled.div`
  position: absolute;
  z-index: 1000;
  right: 100%;
  top: 300px;
  border: 1px solid lightgrey;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 2px;
`;

const Swatch = styled.div`
  border: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(0, 0, 0, 0.07);
  background-color: ${props => props.colour};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

const Cover = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

const Button = styled(WveInputButton)`
  margin-left: auto;
`;

class WveInputColor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showColourPicker: false,
      hex: this.props.hex,
      alphaPercentage: this.props.alphaPercentage,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      hex: nextProps.hex,
      alphaPercentage: nextProps.alphaPercentage,
    });
  }

  handleAlphaChange = (e) => this.setState({ alphaPercentage: e.target.value });
  handleHexChange = (e) => this.setState({ hex: e.target.value });
  handleBlur = (e) => {
    const { newHex, newAlpha } = this.props.handleUpdate(e);
    this.setState({ hex: newHex, alphaPercentage: newAlpha });
  };

  handleHexKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.hexInput.blur();
    } else {
      this.props.handleUpdate(e);
    }
  };
  handleAlphaKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.alphaInput.blur();
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      this.props.handleUpdate(e);
      e.preventDefault();
    } else {
      this.props.handleUpdate(e);
    }
  };

  showColourPicker = () => this.setState({ showColourPicker: true });
  closeColourPicker = () => this.setState({ showColourPicker: false });

  render = () => {
    const {
      props: {
        rgba,
        title,
        handleUpdate,
        placeholder,
        step,
        handleKeyUp,
        disabled,
      },
      showColourPicker,
      closeColourPicker,
      handleAlphaChange,
      handleHexChange,
      handleBlur,
      handleHexKeyDown,
      handleAlphaKeyDown
    } = this;

    const isMultiple = this.state.hex === MULTIPLE;
    const valueToShow = isMultiple ? MULTIPLE : this.state.hex.split('#')[1];

    return (
      <div
        className="wve-input-pair"
      >
        <Swatch
          colour={rgba}
          onClick={showColourPicker}
          disabled={disabled}
        />
        <div
          className={`wve-form-item wve-input-hint
            ${title !== '' && ' wve-input-hint-left '}
          `}
          data-hint-left={title}
          style={{ marginLeft: 0 }}
        >
          <input
            type="text"
            maxLength="6"
            pattern="^#([A-Fa-f0-9]{6})$"
            className={'form-control input-sm'}
            required=""
            value={valueToShow}
            onChange={handleHexChange}
            onBlur={handleBlur}
            onKeyUp={handleHexKeyDown}
            name="hex"
            ref={(hexInput) => {this.hexInput = hexInput}}
            disabled={disabled}
          />
        </div>

        <div
          className="wve-form-item wve-form-item-short wve-input-hint wve-input-hint-right"
          data-hint-right={'%'}
        >
          <input
            type="number"
            className="form-control input-sm"
            placeholder={placeholder}
            value={this.state.alphaPercentage}
            required=""
            min={0}
            max={100}
            step={step}
            onChange={handleAlphaChange}
            onBlur={handleBlur}
            onKeyUp={handleAlphaKeyDown}
            name="alpha"
            ref={(alphaInput) => { this.alphaInput = alphaInput; }}
            disabled={disabled}
          />
        </div>

        {this.state.showColourPicker &&
          <ColourPickerContainer>
            <Cover
              onClick={closeColourPicker}
            />
            <Button
              classes="bg-transparent no-border"
              onClick={closeColourPicker}
            >
              <i className="pg pg-close" />
            </Button>
            <ChromePicker
              color={rgba}
              onChange={handleUpdate}
            />
          </ColourPickerContainer>
        }
      </div>
    );
  }
}

WveInputColor.defaultProps = {
  disabled: false,
  title: '',
  step: 1,
  placeholder: '',
  handleKeyUp: {},
  rgba: 'rgba(255, 255, 255, 1)',
};

WveInputColor.propTypes = {
  title: PropTypes.string,
  hex: PropTypes.string.isRequired,
  alphaPercentage: PropTypes.number.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  rgba: PropTypes.string,
  step: PropTypes.number,
  handleKeyUp: PropTypes.func,
};

export default WveInputColor;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputColor/WveInputColor.jsx